import { GetSizes } from 'smg/customer-api/lineitems';
import * as html from 'smg/html';
import { DollarFormat } from 'smg/util';

export default async function main() {
    const $tableContainer = document.querySelector<HTMLElement>('#buttons-pricing-table');

    const $table = html.FromString(`<div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr></tr>
                    </thead>
                    <tbody>
                    </tbody>
                </table>
        </div>`);

    $tableContainer?.appendChild($table);
    await GetSizes('buttons', 'Celluloid Button (4 Color Imprint)').then(resp => {
        const qtys = [];
        for (const size of resp) {
            const $tr = html.FromString(`<tr>
                <th scope="row">${html.Escape(size.name)}</th>
                </tr`);
            const prices = size.prices;
            for (const price of prices) {
                qtys.push(price.quantity);
                const $td = html.FromString(`<td>${DollarFormat(price.price)}</td>`);
                $tr.appendChild($td);
            }
            $table.querySelector('tbody')?.appendChild($tr);
        }
        const qtysSet = new Set(qtys);
        const $sizeTh = html.FromString('<th scope="col">Size</th>');
        const $theadRow = $table.querySelector<HTMLElement>('thead tr');
        $theadRow?.appendChild($sizeTh);
        for (const qty of qtysSet) {
            const $th = html.FromString(`<th scope="col">${qty.toLocaleString()}</th>`);
            $theadRow?.appendChild($th);
        }
    });
}